module.exports = __webpack_public_path__ + "img/15.69a10e26.svg";